import React, { Component } from "react";
import { Menu } from "antd";
import { queryApprovalUserCached } from '../../common/permissionCache';

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'record';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = {
            current,
            haveQuotationMenu: false,
            haveQuotationWorkUnitPrice: false,
        };
    }

    componentDidMount() {
        this.queryApprovalUser();
    }

    // 获取标准访视单价菜单权限
    queryApprovalUser = () => {
        queryApprovalUserCached(undefined, res => {
            const { haveQuotationMenu, haveQuotationWorkUnitPrice } = res;
            this.setState({
                haveQuotationMenu,
                haveQuotationWorkUnitPrice,
            });
        });
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render () {
        const { current, haveQuotationMenu, haveQuotationWorkUnitPrice } = this.state;
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe8cd;</i><span>商务报价</span></span>}>
                        {
                            haveQuotationMenu && <Menu.Item key="record">
                                <a href="#/businessOffer/businessOfferRecord">商务报价记录</a>
                            </Menu.Item>
                        }
                        {
                            haveQuotationWorkUnitPrice && <Menu.Item key="task">
                                <a href="#/businessOffer/taskUnitPrice">工作任务单价</a>
                            </Menu.Item>
                        }
                        {
                            haveQuotationWorkUnitPrice && <Menu.Item key="siteStartServiceFeePercent">
                                <a href="#/businessOffer/siteStartServiceFeePercent">中心启动服务费用占比</a>
                            </Menu.Item>
                        }
                        {
                            haveQuotationWorkUnitPrice && <Menu.Item key="hours">
                                <a href="#/businessOffer/businessVisitingHours">访视工时</a>
                            </Menu.Item>
                        }
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/businessOffer/SideNav.js